import { Button, H2 } from "@sellar-io/components";
import { useIntercom } from "react-use-intercom";
import { useFullPageDialogContext } from "../../../../../../../../components/modal/useFullPageDialogContext";
import {
  SellarCreditTwoDialogPage,
  SellarCreditTwoHeroImage,
} from "./SellarCreditTwoDialogPage";

export const SellarCreditCheckLoginPrompt = () => {
  const { onDismiss } = useFullPageDialogContext();
  const intercom = useIntercom();

  return (
    <SellarCreditTwoDialogPage contentClassName="gap-4">
      <SellarCreditTwoHeroImage
        src="https://sellar.imgix.net/sellar-image-assets/sellar-credit/login-retry.svg"
        width={178}
        height={170}
        className="w-[178px]"
      />
      <H2>
        Log in to your account on your device to complete Sellar Credit
        onboarding
      </H2>
      <p>
        It’s important to make sure you are using the correct account, as this
        is where your company management controls will be saved to
      </p>
      <div className="mt-6 flex w-full flex-col gap-2">
        <Button className="w-full" onClick={onDismiss}>
          I understand
        </Button>
        <Button
          color="secondary"
          className="w-full"
          onClick={() => intercom.show()}
        >
          Contact support
        </Button>
      </div>
    </SellarCreditTwoDialogPage>
  );
};
